import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetComponent } from './auth/reset/reset.component';
import { TechnicianDetailsComponent } from './auth/technician-details/technician-details.component';

import { CreateNewModalComponent } from './modal/create-new-modal/create-new-modal.component';
import { AuthInterceptorService } from './interceptors/auth-interceptor.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthGurdService } from './auth-gurd/auth-gurd.service';

// firebase
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { IspAcceptRejectComponent } from './components/isp-accept-reject/isp-accept-reject.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    CreateNewModalComponent,
    IspAcceptRejectComponent,
    TechnicianDetailsComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgbModule.forRoot(),
    HttpClientModule,
    NgxSpinnerModule,
    AngularFireModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,AngularMultiSelectModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
  ],
  entryComponents: [
    CreateNewModalComponent,
    IspAcceptRejectComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, 
      useClass: AuthInterceptorService, 
      multi: true,
    },
    AuthGurdService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }